import { computed } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from "@tanstack/vue-query";
import { listMercuryTransactionsQuery } from "@vendata/power-up-sdk/requests/mercury-transactions/list";

export function useTransactionsLoader() {
  const route = useRoute();
  const outstanding = computed(() =>
    route.query.outstanding === "true" ? true : undefined,
  );

  return {
    transactionsQuery: useQuery(
      listMercuryTransactionsQuery({ outstanding }),
    ),
  };
}
